import { render } from "./MyFooter.vue?vue&type=template&id=50aa58cb"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dropbox\\CrazyCat\\vue\\crazycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__